module.exports = __webpack_public_path__ + "media/store/images/Rectangle 5-c9c6219db58903c1b3cb920b43511aad.png";